<template>
  <div class="megamenu-location-group">
    <ul class="megamenu-location-group__list">
      <li
        class="megamenu-location-group__list-item list-medium"
        v-for="navigationTreeItem of navigationTree"
        :key="navigationTreeItem.id"
      >
        <a
          class="megamenu-location-group__link px-1.5"
          :href="(navigationTreeItem.path as string)"
          @click.prevent="$emit('clickLocationLink', navigationTreeItem)"
          itemprop="url"
        >
          <span itemprop="name"> {{ navigationTreeItem.label }}</span>
        </a>

        <ul
          v-if="showChildren && navigationTreeItem.children"
          class="megamenu-location-group__level3-list"
        >
          <li
            class="megamenu-location-group__level3-list-item list-medium"
            v-for="level3NavigationTreeItem of navigationTreeItem.children"
            :key="level3NavigationTreeItem.id"
          >
            <a
              class="megamenu-location-group__level3-link"
              :href="(level3NavigationTreeItem.path as string)"
              @click.prevent="
                $emit('clickLocationLink', level3NavigationTreeItem)
              "
              itemprop="url"
              ><span itemprop="name">
                {{ level3NavigationTreeItem.label }}</span
              >
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { NavigationTree } from '@/store/navigation/models/NavigationTree';
import { DKLink } from '@dormakaba/dormakaba-components';

@Component({
  components: {
    DKLink,
  },
  emits: ['clickLocationLink'],
})
export default class MegamenuLocationGroup extends Vue {
  @Prop({ default: [] }) navigationTree!: NavigationTree;
  @Prop({ default: true }) showChildren!: boolean;
}
</script>

<style lang="postcss" scoped>
.megamenu-location-group {
  @apply py-4;
}

.megamenu-location-group__list {
  @apply p-0;
}

.megamenu-location-group__list-item {
  @apply flex justify-between;
  @apply list-none;

  & span {
    line-height: 26px;
    font-weight: 400;
  }

  & .megamenu-location-group__level3-link,
  & .megamenu-location-group__link--active span {
    @apply font-familyBold;
  }
}

.megamenu-location-group__link {
  @apply inline;
  @apply text-black;

  &:hover {
    @apply text-red-dk;
  }

  & span {
    @apply font-familyRegular;
    @apply mr-2;
  }
}

.megamenu-location-group__level3-list {
  @apply flex flex-shrink-0 flex-grow-0;
}

.megamenu-location-group__level3-list-item {
  @apply z-10;
  @apply list-none;
  margin-right: 1px;

  & span {
    @apply leading-15;
    font-weight: 700;
  }
}

.megamenu-location-group__level3-link {
  @apply flex items-center justify-center;
  @apply font-familyBold p-small;
  @apply text-black;
  @apply bg-grey-cool-5;
  @apply rounded-lg;
  padding: 0 6px;
  width: 34px;
  height: 26px;

  &:hover {
    @apply bg-grey-cool-10;
  }
}

.megamenu-location-group__level3-link--active {
  @apply bg-black;
  @apply text-white;

  &:hover {
    @apply bg-black;
  }
}
</style>
